// @ts-expect-error routable injected globally
export const getChecklistDataUrl = routable.getRoute('getChecklistData');
// @ts-expect-error routable injected globally
export const updateChecklistDataUrl = routable.getRoute('updateChecklistData');
// @ts-expect-error routable injected globally
export const deleteChecklistDataUrl = routable.getRoute('deleteChecklistData');
// @ts-expect-error routable injected globally
export const switchChecklistItemUrl = routable.getRoute('switchChecklistItem');
